<template>
    <CModal
            width="1000px"
            v-model="visible"
            :title="title"
            @on-ok="onCancel"
            @on-cancel="onCancel">
            <div class="form-area">
            <Form style="width: 900px" :model="model" :label-width="110" label-position="left" inline>
                    <FormItem :class="{'model-hidden': true}" label="文本框">
                        <Input v-model="model.id"  type="text"></Input>
                    </FormItem>
                    <p>基本信息</p>
                    <br>
                    <FormItem label="发布人">
                        <Input :value="model.userName" style="width:320px" type="text" readonly></Input>
                    </FormItem>
<!--                    <FormItem label="受邀时间">-->
<!--                        <Input :value="dayjs(model.createTime).format('YYYY-MM-DD')" style="width:320px" type="text" readonly></Input>-->
<!--                    </FormItem>-->
                    <FormItem  label="企业名称">
                              <Input v-model="model.name" style="width:320px" type="text" readonly></Input>
                    </FormItem>
                    <FormItem label="信用代码">
                              <Input v-model="model.code" style="width:320px" type="text" readonly></Input>
                    </FormItem>
                    <FormItem label="企业联系人">
                              <Input v-model="model.concat" style="width:320px" type="text" readonly></Input>
                    </FormItem>
                    <FormItem label="联系方式">
                              <Input v-model="model.phone" style="width:320px" type="text" readonly/>
                    </FormItem>
<!--                    <FormItem label="受邀单位">-->
<!--                        <Input v-model="model.visitUnitName" style="width:320px" type="text" readonly></Input>-->
<!--                    </FormItem>-->
                    <FormItem label="走访时间">
                        <Input :value="dayjs(model.visitStartTime).format('YYYY-MM-DD') + ' - ' + dayjs(model.visitEndTime).format('YYYY-MM-DD')" style="width:320px" type="text" readonly></Input>
                    </FormItem>
                    <FormItem label="走访内容">
                        <Input :rows="4" :value="model.visitContent" style="width:760px" type="textarea" readonly></Input>
                    </FormItem>
                    <div v-show="row.visitStatus==1">
                    <p>回访信息</p>
                    <br>
                    <FormItem label="您的姓名">
                              <Input v-model="model.name" style="width:320px" type="text" readonly></Input>
                    </FormItem>
                    <FormItem label="联系方式">
                              <Input v-model="model.phone" style="width:320px" type="text" readonly></Input>
                    </FormItem>
                    <FormItem label="服务时间" prop="appealExtendServiceTime">
                        <Input v-model="model.appealExtendServiceTime" style="width:320px" type="text" readonly></Input>
                    </FormItem>
                    <FormItem label="服务类型" prop="appealExtendService">
                        <Input v-model="model.appealExtendService" style="width:320px" type="text" readonly></Input>
                    </FormItem>
                    <FormItem label="服务备注" prop="appealExtendRemark">
                              <Input v-model="model.appealExtendRemark" style="width:320px" type="text" readonly></Input>
                    </FormItem>
                </div>

            </Form>
        </div>


</CModal>
</template>
<script>
    import CModal from '@/components/cModel'
    import dayjs from 'dayjs'

    export default {
        components: {
            CModal
        },
        data() {
            return {
                loading: false,
                visible: false,
                title: '',
                type: '',
                id: '',
                model: {},
                row: {}
            }
        },
        watch: {
            id(val) {
                this.chakan1(val)
            }
        },

        mounted() {

        },
        methods: {
            dayjs,
            onCancel() {
                this.model = {}
                this.visible = false
            },

            chakan(row) {
                this.row = row
                this.$util.http.get(`/api/tqtAppeals/${row.id}`).then(res => {
                    this.model = res.data
                    switch (this.model.appealExtendService) {
                        case 1:
                            this.model.appealExtendService = '检查'
                            break;
                        case 2:
                            this.model.appealExtendService = '走访'
                            break;
                        case 3:
                            this.model.appealExtendService = '调研'
                            break;
                        case 4:
                            this.model.appealExtendService = '执法'
                            break;
                        case 5:
                            this.model.appealExtendService = '其他'
                            break;
                        default:
                            this.model.appealExtendService = ''
                    }
                    this.model.visitStartTime && (this.model.visitStartTime = dayjs(this.model.visitStartTime).format('YYYY-MM-DD HH:mm:ss ')) // display
                })
            },


        }

    }
</script>

<style scoped>
    .title {
        display: flex;
        border-bottom: none;
        height: 50px;
        line-height: 50px;
        font-size: 16px;
        padding-left: 6px;
    }

    .p {
        width: 33%;
        text-align: center;
    }

    .model-hidden {
        display: none;
    }
</style>
